import styled from 'styled-components';
import ScrollbarNormalize from 'commonStyles/ScrollbarNormalize';

const scrollNormalized = styled(ScrollbarNormalize)`
  background: #fff;
  min-width: 50rem;
  max-width: ${props => props.maxWidth};
  width: ${props => props.width};
  height: auto;
  min-height: 20rem;
  box-shadow: 5px 5px 5px #0000001c;
  z-index: 300;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 1rem;
  padding: 3rem;
  padding-bottom: 4rem;
`;

export default scrollNormalized;
